<script>
    import { Bar } from 'vue-chartjs'
    import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'

    export default {
        extends: Bar,
        props: ['height', 'bar_data'],
        created () {
            this.bar_data.bus.$on('updateChart', () => {
                this.renderLineChart();
            });
        },
        mounted () {
            this.renderLineChart();
        },
        methods: {
            renderLineChart() {
                // Overwriting base render method with actual data.
                this.renderChart(
                    {
                        labels: this.bar_data.label,
                        datasets: [
                            {
                                label: 'Click Counts',
                                backgroundColor: '#f87979',
                                data: this.bar_data.data
                            }
                        ]
                    },
                    {
                        responsive: true,
                        maintainAspectRatio: true,
                        tooltips: {
                            enabled: false,
                            custom: CustomTooltips,
                            intersect: true,
                            mode: 'index',
                            position: 'nearest',
                            callbacks: {
                                labelColor: function (tooltipItem, chart) {
                                    return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor }
                                }
                            }
                        }
                    }
                )
            }
        }
    }
</script>


<style scoped>

</style>